import React from 'react'
import PropTypes from 'prop-types'
import { ToggleButton, ToggleButtonGroup, Typography } from '@mui/material'
import { Controller } from 'react-hook-form'
import ServiceTypeAvatar from 'components/common/avatar/ServiceTypeAvatar'
import { RECURRENCE } from 'settings/constants/service'
import { PRICED_SERVICE_TYPE } from 'components/configured-service/CreateDraftConfiguredServiceDialog/settings'
import T from 'T'
import { capitalize } from 'lodash'

/**
 * Specialized Toggle Button Group for recurrence filtering.
 * Always includes ServiceTypeAvatar and uses an exclusive (single-selection) value.
 */
const RecurrenceFilterToggleButtonGroup = ({ name, control, label, defaultValue, size = 'small', fullWidth = true }) => {
  return (
    <>
      {label && (
        <Typography variant="subtitle2" gutterBottom>
          {label}
        </Typography>
      )}
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ field }) => (
          <ToggleButtonGroup
            {...field}
            exclusive
            aria-label={name}
            fullWidth={fullWidth}
            size={size}
            onChange={(_, newValue) => {
              // Prevent deselecting the active button — a recurrence type must always be selected
              if (newValue !== null) {
                field.onChange(newValue)
              }
            }}
          >
            {[
              { label: T.RECURRING, value: PRICED_SERVICE_TYPE.RECURRING },
              { label: T.ON_REQUEST, value: PRICED_SERVICE_TYPE.ON_REQUEST },
            ].map(option => {
              const isSelected = field && field.value === option.value

              return (
                <ToggleButton
                  key={`${name}-${option.value}`}
                  value={option.value}
                  sx={{
                    display: 'flex',
                    gap: 1,
                    alignItems: 'center',
                    justifyContent: 'center',
                    textTransform: 'none',
                  }}
                >
                  <ServiceTypeAvatar
                    serviceType={option.value === PRICED_SERVICE_TYPE.RECURRING ? RECURRENCE.RECURRING : RECURRENCE.ON_REQUEST}
                    isDraft={!isSelected}
                  />
                  {capitalize(option.label)}
                </ToggleButton>
              )
            })}
          </ToggleButtonGroup>
        )}
      />
    </>
  )
}

RecurrenceFilterToggleButtonGroup.propTypes = {
  name: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  label: PropTypes.string,
  defaultValue: PropTypes.any,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  fullWidth: PropTypes.bool,
}

export default RecurrenceFilterToggleButtonGroup
